import { useState } from 'react';
import { BUDGET, HOME_SIZE, HOME_TYPE } from './formConstants';

export default function ContactForm() {
  const [result, setResult] = useState("");

  const onSubmit = async (event: any) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    formData.append("access_key", process.env.REACT_APP_WEB3FORM_API_KEY!);

    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData
    });

    const data = await response.json();
    setResult(data.success ? "Success!" : "Error");
  };

  return (
    <form onSubmit={onSubmit}>
			{/* Name Field */}
			<div className="form-group">
				<label htmlFor="name" className="form-label">
					Name <span className="required">*</span>
				</label>
				<input
					type="text"
					id="name"
					name="name"
					maxLength={150}
					placeholder="Preferred name"
					className="form-input"
					required
				/>
			</div>

			{/* Email Field */}
			<div className="form-group">
				<label htmlFor="email" className="form-label">
					Email <span className="required">*</span>
				</label>
				<input
					type="text"
					id="email"
					name="email"
					maxLength={150}
					placeholder="Your email"
					className="form-input"
					required
				/>
			</div>
			
			{/* Home Type */}
			<div className="form-group">
				<label htmlFor="home-type" className="form-label">
					Type of home
				</label>
				<select
					id="home-type"
					name="home-type"
					className="form-select"
				>
					<option value=""></option>
					{ Object.entries(HOME_TYPE).map(([key, value]) => (
						<option value={key}>{value}</option>
					)) }
				</select>
			</div>

			{/* Home Size */}
			<div className="form-group">
				<label htmlFor="home-size" className="form-label">
					Size of home
				</label>
				<select
					id="home-size"
					name="home-size"
					className="form-select"
				>
					<option value=""></option>
					{ Object.entries(HOME_SIZE).map(([key, value]) => (
						<option value={key}>{value}</option>
					)) }
				</select>
			</div>

			{/* Home Budget */}
			<div className="form-group">
				<label htmlFor="budget" className="form-label">
					Budget
				</label>
				<select
					id="budget"
					name="budget"
					className="form-select"
				>
					<option value=""></option>
					{ Object.entries(BUDGET).map(([key, value]) => (
						<option value={key}>{value}</option>
					)) }
				</select>
			</div>

			{/* Timeline */}
			<div className="form-group">
				<label htmlFor="timeline" className="form-label">
					Timeline
				</label>
				<input
					type="text"
					id="timeline"
					name="timeline"
					maxLength={250}
					placeholder="What's your timeline?"
					className="form-input"
				/>
			</div>

			{/* Description */}
			<div className="form-group">
				<label htmlFor="description" className="form-label">
					Project description <span className="required">*</span>
				</label>
				<input
					type="text"
					id="description"
					name="description"
					maxLength={800}
					placeholder="Describe your dream home"
					className="form-input"
					required
				/>
			</div>

      <button type="submit">Submit</button>
      <p>{result}</p>
    </form>
  );
}